var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-w my-6 d-flex align-center justify-center",staticStyle:{"gap":"0.4rem"}},[_c('v-icon',{attrs:{"small":"","color":"grey"}},[_vm._v("mdi-information-outline")]),_c('p',{staticClass:"text-caption grey--text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }